import React, { useState, useEffect } from 'react';
import { getProductData } from './api/bigcommerce';
import ThreeDViewer from './components/ThreeDViewer';

const PRODUCT_ID = '12345'; // Replace '12345' with your actual product ID

const App = () => {
  const [productData, setProductData] = useState(null);
  const [modelPath, setModelPath] = useState('/path/to/default/model.gltf');

  useEffect(() => {
    const fetchProductData = async () => {
      const data = await getProductData(PRODUCT_ID);
      setProductData(data);
    };

    fetchProductData();

    const updateModelPath = () => {
      const selectedOptions = {};
      document.querySelectorAll('.product-option select').forEach((select) => {
        const optionId = select.getAttribute('data-option-id');
        const value = select.value;
        selectedOptions[optionId] = value;
      });

      // Update modelPath based on selected options
      const newPath = `/path/to/model/${Object.values(selectedOptions).join('_')}.gltf`;
      setModelPath(newPath);
    };

    const observer = new MutationObserver(updateModelPath);

    document.querySelectorAll('.product-option select').forEach((select) => {
      observer.observe(select, { attributes: true, childList: true, subtree: true });
      select.addEventListener('change', updateModelPath);
    });

    return () => {
      observer.disconnect();
      document.querySelectorAll('.product-option select').forEach((select) => {
        select.removeEventListener('change', updateModelPath);
      });
    };
  }, []);

  return (
    <div>
      <h1>3D Model Viewer</h1>
      {productData && (
        <div>
          <ThreeDViewer modelPath={modelPath} />
        </div>
      )}
    </div>
  );
};

export default App;
